function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(d.getTime());
  // Set to the first Thursday of the year
  d.setDate(d.getDate() - d.getDay() + 5);
  // Get first Thursday of the year
  var week1 = new Date(d.getFullYear(), 0, 4);
  // Calculate full weeks to nearest Thursday
  var weekNumber = Math.ceil(((d - week1) / 86400000 + 1) / 7);
  return weekNumber;
}

document.addEventListener('DOMContentLoaded', function() {
  var weekNumber = getWeekNumber(new Date());
  var weekElement = document.getElementById('current-week');
  if (weekElement) {
    weekElement.innerText = 'week: ' + weekNumber;
  }
});
